module.exports = __webpack_public_path__ + "static/media/1005053.1949fd89.png";